// Course catalog — generated by scripts/release/index.ts --course.
// Source of truth: dibia/course/course-manifest.json. Do not hand-edit.

export type CourseTier = "public" | "pro";

export interface CourseDeck {
  id: string;
  chapter: number;
  part: string;
  title: string;
  topic: string;
  slides: number;
  minutes: number;
  demos: number;
  tier: CourseTier;
  pdf: string;
  pages: number;
  /** Direct URL for free decks (public storage). Absent for paid decks. */
  publicUrl?: string;
}

/** Feature key that unlocks the whole course (Professional and up). */
export const COURSE_FEATURE = "course:complete";

export const courseTotals = {"decks":16,"slides":538,"minutes":347,"demos":20};

export const courseDecks: CourseDeck[] = [
  {
    "id": "ch01-understanding-multiagent-systems",
    "chapter": 1,
    "part": "Part I — Foundations",
    "title": "Understanding Multi-Agent Systems",
    "topic": "Foundations",
    "slides": 30,
    "minutes": 15,
    "demos": 1,
    "tier": "public",
    "pdf": "ch01-understanding-multiagent-systems.pdf",
    "pages": 31,
    "publicUrl": "https://storage.googleapis.com/multiagent-book.firebasestorage.app/public/course/ch01-understanding-multiagent-systems.pdf"
  },
  {
    "id": "ch02-multiagent-patterns",
    "chapter": 2,
    "part": "Part I — Foundations",
    "title": "Multi-Agent Patterns",
    "topic": "The Autonomy Spectrum",
    "slides": 38,
    "minutes": 18,
    "demos": 1,
    "tier": "public",
    "pdf": "ch02-multiagent-patterns.pdf",
    "pages": 39,
    "publicUrl": "https://storage.googleapis.com/multiagent-book.firebasestorage.app/public/course/ch02-multiagent-patterns.pdf"
  },
  {
    "id": "ch03-ux-of-multiagent-systems",
    "chapter": 3,
    "part": "Part I — Foundations",
    "title": "The UX of Multi-Agent Systems",
    "topic": "Designing for Delegation",
    "slides": 27,
    "minutes": 15,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch03-ux-of-multiagent-systems.pdf",
    "pages": 28
  },
  {
    "id": "ch04-building-first-agent",
    "chapter": 4,
    "part": "Part II — Building From Scratch",
    "title": "Building Your First Agent",
    "topic": "The Complete Build, From Loop to Human-in-the-Loop",
    "slides": 49,
    "minutes": 32,
    "demos": 4,
    "tier": "pro",
    "pdf": "ch04-building-first-agent.pdf",
    "pages": 50
  },
  {
    "id": "ch05-computer-use-agents",
    "chapter": 5,
    "part": "Part II — Building From Scratch",
    "title": "Computer Use Agents",
    "topic": "Agents That See the Screen and Click",
    "slides": 40,
    "minutes": 24,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch05-computer-use-agents.pdf",
    "pages": 41
  },
  {
    "id": "ch06-building-multiagent-workflows",
    "chapter": 6,
    "part": "Part II — Building From Scratch",
    "title": "Building Multi-Agent Workflows",
    "topic": "Graphs You Can Trust",
    "slides": 29,
    "minutes": 18,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch06-building-multiagent-workflows.pdf",
    "pages": 30
  },
  {
    "id": "ch07-autonomous-multiagent-orchestration",
    "chapter": 7,
    "part": "Part II — Building From Scratch",
    "title": "Autonomous Multi-Agent Orchestration",
    "topic": "One Loop, Three Patterns",
    "slides": 34,
    "minutes": 23,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch07-autonomous-multiagent-orchestration.pdf",
    "pages": 35
  },
  {
    "id": "ch08-agent-web-applications",
    "chapter": 8,
    "part": "Part II — Building From Scratch",
    "title": "Agent Web Applications",
    "topic": "Build It in 200 Lines, Ship It Statelessly",
    "slides": 29,
    "minutes": 23,
    "demos": 2,
    "tier": "pro",
    "pdf": "ch08-agent-web-applications.pdf",
    "pages": 30
  },
  {
    "id": "ch09-multiagent-frameworks",
    "chapter": 9,
    "part": "Part II — Building From Scratch",
    "title": "Multi-Agent Frameworks",
    "topic": "Capabilities, and the Adopt-or-Build Decision",
    "slides": 29,
    "minutes": 21,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch09-multiagent-frameworks.pdf",
    "pages": 30
  },
  {
    "id": "ch10-evaluating-multiagent-systems",
    "chapter": 10,
    "part": "Part III — Evaluation, Optimization & Responsibility",
    "title": "Evaluating Multi-Agent Systems",
    "topic": "Measure First, Then Build",
    "slides": 34,
    "minutes": 28,
    "demos": 2,
    "tier": "pro",
    "pdf": "ch10-evaluating-multiagent-systems.pdf",
    "pages": 35
  },
  {
    "id": "ch11-optimizing-multiagent-systems",
    "chapter": 11,
    "part": "Part III — Evaluation, Optimization & Responsibility",
    "title": "Optimizing Multi-Agent Systems",
    "topic": "Optimization Priority and Ten Failure Modes",
    "slides": 36,
    "minutes": 20,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch11-optimizing-multiagent-systems.pdf",
    "pages": 37
  },
  {
    "id": "ch12-protocols-distributed-agents",
    "chapter": 12,
    "part": "Part III — Evaluation, Optimization & Responsibility",
    "title": "Protocols for Distributed Agents",
    "topic": "MCP, A2A, and the Ground They Share",
    "slides": 37,
    "minutes": 22,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch12-protocols-distributed-agents.pdf",
    "pages": 38
  },
  {
    "id": "ch13-ethics-responsible-ai",
    "chapter": 13,
    "part": "Part III — Evaluation, Optimization & Responsibility",
    "title": "Ethics & Responsible AI",
    "topic": "When Agents Can Act",
    "slides": 36,
    "minutes": 25,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch13-ethics-responsible-ai.pdf",
    "pages": 37
  },
  {
    "id": "ch14-business-questions-unstructured-data",
    "chapter": 14,
    "part": "Part IV — Real-World Applications",
    "title": "Answering Business Questions from Unstructured Data",
    "topic": "The YC Analysis, End to End",
    "slides": 34,
    "minutes": 23,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch14-business-questions-unstructured-data.pdf",
    "pages": 35
  },
  {
    "id": "ch15-software-engineering-agent",
    "chapter": 15,
    "part": "Part IV — Real-World Applications",
    "title": "Building a Software Engineering Agent",
    "topic": "The Pattern Behind Cursor and Claude Code",
    "slides": 29,
    "minutes": 23,
    "demos": 1,
    "tier": "pro",
    "pdf": "ch15-software-engineering-agent.pdf",
    "pages": 30
  },
  {
    "id": "ch16-epilogue-looking-forward",
    "chapter": 16,
    "part": "Part IV — Real-World Applications",
    "title": "Looking Forward",
    "topic": "Epilogue",
    "slides": 27,
    "minutes": 17,
    "demos": 0,
    "tier": "pro",
    "pdf": "ch16-epilogue-looking-forward.pdf",
    "pages": 28
  }
];

export const coursePartOrder: string[] = [
  "Part I — Foundations",
  "Part II — Building From Scratch",
  "Part III — Evaluation, Optimization & Responsibility",
  "Part IV — Real-World Applications"
];
